import { Sparkles } from "lucide-react";

/**
 * StarAvatarFallback
 * --------------------------------------------------------------
 * Brand-aligned avatar placeholder shown when a star (creator) has
 * not uploaded a profile picture yet. Uses the FoundStar gradient
 * (pink → purple) plus a sparkle icon so creators look polished
 * to brands instead of showing a plain letter.
 *
 * Usage:
 *   <Avatar>
 *     <AvatarImage src={url} />
 *     <AvatarFallback className="p-0 bg-transparent overflow-hidden">
 *       <StarAvatarFallback />
 *     </AvatarFallback>
 *   </Avatar>
 *
 * Props:
 *   - iconClassName: tailwind classes to size/colour the sparkle
 *   - className: extra wrapper classes
 */
export default function StarAvatarFallback({
  iconClassName = "w-1/2 h-1/2",
  className = "",
}) {
  return (
    <div
      className={`relative w-full h-full flex items-center justify-center bg-gradient-to-br from-[#FF8FCF] via-[#C77DFF] to-[#7B2FBE] ${className}`}
      aria-label="No profile picture"
    >
      {/* soft inner glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_25%,rgba(255,255,255,0.45),transparent_55%)]" />
      <Sparkles
        className={`relative text-white drop-shadow-md ${iconClassName}`}
        strokeWidth={2.25}
        fill="white"
        fillOpacity={0.25}
      />
    </div>
  );
}
